import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { ReactComponent as AddCircle } from '../../../../../assets/icons/add-circle.svg'
import { ReactComponent as Add } from '../../../../../assets/icons/plus.svg'
import useOnClickOutside from '../../../../../hooks/useOnClickOutside'

import styles from './add-new-tab.module.scss'

function AddNewTab() {
    const { t } = useTranslation()

    const navigate = useNavigate()

    const [addingTab, setAddingTab] = useState(false)
    const [newTab, setNewTab] = useState('')

    const formRef = useRef(null)

    useOnClickOutside(formRef, () => setAddingTab(false))

    const handleAddNewTab = (e?: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault()

        if (!newTab) return

        setNewTab('')
        navigate(`/training-data/data/${newTab}`)
    }

    return addingTab ? (
        <form
            className={styles.addNewTab}
            onSubmit={handleAddNewTab}
            ref={formRef}
        >
            <input
                className={styles.addNewTab__input}
                value={newTab}
                onChange={(e) => setNewTab(e.target.value)}
                placeholder={t('tab')}
            />
            <button type="submit" className={styles.addNewTab__btn}>
                <Add className={styles.addNewTab__icon} alt={t('add')} />
            </button>
        </form>
    ) : (
        <button
            className={styles.addNewTab__addBtn}
            onClick={() => setAddingTab(true)}
        >
            <AddCircle className={styles.addNewTab__addIcon} />
        </button>
    )
}

export default AddNewTab
